module.exports = __webpack_public_path__ + "static/herobg-07-min-56def2979c312642dc2113cada911b6c.jpg";